// extracted by mini-css-extract-plugin
export default {"fieldset1":"fieldset1___mcia"};